import RequestSummaryItemResourceModel from '../../generated/types/model/resource/RequestSummaryItemResourceModel';

export default class RequestSummaryItemResourceViewModel extends RequestSummaryItemResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
